import apiPublic from "@/services/apiPublic";

export type ReferralInfoType = {
  code: string;
  referrerName: string;
  franchiseCity: string;
  source: "associate" | "franchise";
};

class GetReferralInfo {
  execute = async (code: string) => {
    const response = await apiPublic().get(`/referral/info/${encodeURIComponent(code)}`);
    return response.data as ReferralInfoType;
  };
}

export { GetReferralInfo };
